import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RmvdDatePipeModule } from '../../pipes/rmvdDate.pipe';
import { ActionMenuComponentModule } from '../action-menu/action-menu.component.module';
import { DataObjectIconComponentModule } from '../dataobject-icon/dataobject-icon.component';
import { TagsComponentModule } from '../tags/tags.component.module';
import { TimeseriesPreviewComponentModule } from '../timeseries-preview/timeseries-preview.component.module';
import { GenericTimeSeriesPreviewComponent } from './generic-timeseries-preview.component';

@NgModule({
  declarations: [GenericTimeSeriesPreviewComponent],
  exports: [GenericTimeSeriesPreviewComponent],
  imports: [
    CommonModule,
    ActionMenuComponentModule,
    DataObjectIconComponentModule,
    TagsComponentModule,
    TimeseriesPreviewComponentModule,
    RmvdDatePipeModule,
  ],
})
export class GenericTimeSeriesPreviewComponentModule {}
